export default "__VITE_ASSET__6e48a2f2__"